module.exports = __webpack_public_path__ + "img/user-icon.daae9969.svg";